<div class="contenedor">
  <img *ngIf="tipoAlerta=='success'" src="./assets/Imagenes/like.png" class="imgModal">
  <i *ngIf="tipoAlerta=='error'" class="fas fa-times-circle imgModal iconError"></i>
  <p class="txtTitulo">{{titulo}}</p>
  <p class="txtMensaje">{{mensaje}}</p>
  <input type="button" class="btn btnModal" value="Continuar" (click)="cerrarModal()">
</div>
